import { useCallback, useEffect, useState } from 'react'
import {
  addModel,
  deleteModel,
  isModelFile,
  listModels,
  resetDatabase,
  type ModelAsset,
} from './library'

export interface Library {
  models: ModelAsset[]
  add(files: FileList | File[]): Promise<void>
  remove(id: string): Promise<void>
  reset(): Promise<void>
  refresh(): Promise<void>
}

export function useLibrary(): Library {
  const [models, setModels] = useState<ModelAsset[]>([])

  const refresh = useCallback(async () => {
    setModels(await listModels())
  }, [])

  const add = useCallback(
    async (files: FileList | File[]) => {
      for (const file of Array.from(files)) {
        if (!isModelFile(file.name)) continue
        await addModel(file).catch(() => {}) // skip files that aren't real glb/gltf content
      }
      await refresh()
    },
    [refresh],
  )

  const remove = useCallback(
    async (id: string) => {
      await deleteModel(id)
      await refresh()
    },
    [refresh],
  )

  const reset = useCallback(async () => {
    await resetDatabase()
    await refresh()
  }, [refresh])

  useEffect(() => {
    let active = true
    listModels().then((m) => {
      if (active) setModels(m)
    })
    return () => {
      active = false
    }
  }, [])

  return { models, add, remove, reset, refresh }
}
